module.exports = __webpack_public_path__ + "img/10873_L.59f52f07.png";